import { DASHBOARD_COLUMN_PX } from './dashboardGrid';

/**
 * ─────────────────────────────────────────────────────────────────────────────────
 *  [P7C §2] DUTY ANALYTICS' LITERAL CLASSES, AND THE ARITHMETIC THEY STAND ON.
 *
 *  ⚠️ LITERALS, NEVER INTERPOLATED. Tailwind extracts candidates from source TEXT, so a class built
 *  with a template string generates nothing — the grid would render one column at every width and
 *  the table would grow to fit forty rows, with `tsc`, `eslint` and `vitest` all green.
 *  `dutyAnalyticsLayout.test.ts` pins each literal against the numbers below (`dashboardGrid.ts`'
 *  discipline, one page over).
 *
 *  ⚠️ CONTAINER QUERIES ON `<main>`, NEVER A WINDOW BREAKPOINT, and no upper-bound variant anywhere —
 *  a pure ascending cascade has no uncovered interval (§8's complementarity rule).
 * ─────────────────────────────────────────────────────────────────────────────────
 */

/**
 * The four headline cards: two across from `DASHBOARD_COLUMN_PX.two`, four from `.four`.
 *
 * ⚠️ NO THREE-COLUMN STEP, DELIBERATELY. Four cards at three columns read 3+1 — [P6a]'s "broken
 * row" — so between the two thresholds they stay 2×2. At the 1366 floor `<main>` has 1062 content
 * pixels: two across, 2×2. Collapsing the sidebar at 1440 (1336) buys the single row of four.
 */
export const DA_CARD_COLUMN_PX = { two: DASHBOARD_COLUMN_PX.two, four: DASHBOARD_COLUMN_PX.four } as const;
export const DA_CARD_GRID = 'grid grid-cols-1 gap-4 @min-[656px]:grid-cols-2 @min-[1328px]:grid-cols-4';

/**
 * ⚠️ THE FIGURES TABLE SCROLLS INSIDE ITS CARD, AND THE CAP IS ARITHMETIC: twelve 40-pixel rows
 * (`h-10` cells) under a 40-pixel sticky header. A literal, for rule one above.
 *
 * ⚠️ `overscroll-behavior` STAYS AT ITS DEFAULT — [C1e §1a]'s rule for a list in the page flow.
 * Containing it would trap the wheel at either end, and reading the table to its last row is a
 * natural continuation into the rest of the page. `relative` keeps any absolutely positioned
 * descendant inside the scroller (the [D4] sr-only lesson).
 */
export const DA_TABLE_ROW_PX = 40;
export const DA_TABLE_VISIBLE_ROWS = 12;
export const DA_TABLE_SCROLL_MAX_PX = DA_TABLE_ROW_PX * (DA_TABLE_VISIBLE_ROWS + 1);
export const DA_TABLE_SCROLL = 'relative max-h-[520px] overflow-x-auto overflow-y-auto';
/** The header stays in view while the body scrolls under it; `bg-card` so rows do not show through. */
export const DA_TABLE_HEAD = 'sticky top-0 z-10 bg-card';
